import React from "react";
import { MainDiv } from "../../components/Profile/Profile.style";
import StudySetup from "../../components/setup/StudySetup/StudySetup";
import { VolunteerHeading } from "../../components/Volunteer/Volunteer.style";

const StudySetupPage = () => {
  return (
    <MainDiv>
      <VolunteerHeading>Study Setup</VolunteerHeading>
      <StudySetup />
    </MainDiv>
  );
};

export default StudySetupPage;
